export default __webpack_public_path__ + "static/media/search.e5ec5879.svg";